import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';

export default async function getTempPassword() {
  const headers = {};
  await addBrowserSideAppHeaders(headers);

  const response = await fetch('/api/process-temp-user', {
    method: 'POST',
    headers,
  });

  return response.json();
}
